export class ModelGander
    {
        GenderId : Number;
        GenderName :string
    }